import './MainArea.less';
import React from 'react';
import ErrorContext from "../../../contexts/error/ErrorContext";
import {LAYOUT_DASHBOARD, LAYOUT_DEFAULT} from "../../Layout";


export default class MainArea extends React.Component {

    componentDidCatch(error, errorInfo) {
        this.context.setError('Unexpected');

        console.error('ERROR', error);
        console.log('ERROR_INFO', errorInfo);
    }

    getTypeClass = () => {
        switch (this.props.layoutType) {
            case LAYOUT_DASHBOARD:
                return 'type-dashboard';
            case LAYOUT_DEFAULT:
            default:
                return 'type-default';
        }
    };

    render() {
        return <div className={`main-area ${this.getTypeClass()}`}>
            {this.props.content}
        </div>;
    }
}

MainArea.contextType = ErrorContext;
